module.exports = __webpack_public_path__ + "media/images/top_bg-7e4629d9450883f964a1d12a63dd7d48.png";